export default "__VITE_ASSET__adPL14iE__"